<template>
  <div class="loginTable">
    <div id="loginContainer">
      <h1 class="page-title">PSYBooks Login</h1>
      <form-vue />
    </div>
  </div>
</template>

<script>
import FormVue from "./Form.vue";

export default {
  components: {
    FormVue
  }
};
</script>

<style scoped>
@font-face {
  font-family: "BOOKOS";
  src: url("../../../assets/fonts/BOOKOS.eot");
  src: url("../../../assets/fonts/BOOKOS.eot") format("embedded-opentype"),
    url("../../../assets/fonts/BOOKOS.woff2") format("woff2"),
    url("../../../assets/fonts/BOOKOS.woff") format("woff"),
    url("../../../assets/fonts/BOOKOS.ttf") format("truetype"),
    url("../../../assets/fonts/BOOKOS.svg#BOOKOS") format("svg");
}

.loginTable {
  padding: 0;
  margin-top: 30px;
  overflow: hidden;
  clear: both;
  width: 100%;
  margin: 0px auto 0px auto;
}

.loginTable #loginContainer {
  padding: 0;
  max-width: 300px;
  margin: 0 auto;
}

#loginMessage {
  display: block;
  margin: 15px auto;
  text-align: center;
  height: 20px;
  position: relative;
  width: 100%;
}

.error {
  color: #d26d13;
  font-weight: 800;
}

.textCenter {
  text-align: center;
}

.page-title {
  font-family: "BOOKOS";
  font-size: 36px;
  text-align: center;
  color: #d1c8a4;
  font-weight: normal;
  margin-bottom: 10px;
  margin-top: 50px;
}

@media (max-width: 375px) {
  #loginContainer span#loginMessage {
    margin: 5px 0;
  }
}
@media screen and (max-width: 812px) and (max-height: 376px) {
  .page-title {
    font-size: 30px;
    margin-bottom: 0;
    margin-top: 14px;
  }
}

@media screen and (max-width: 600px) and (max-height: 376px) {
  .loginTable #loginContainer {
    max-height: 194px;
    overflow: auto;
  }
}
</style>
